module.exports = __webpack_public_path__ + "static/img/zhibo3.6fac3464.webp";